module.exports = __webpack_public_path__ + "media/new/best-seller-4636bea6.gif";